'use strict';



export default class FineDetails {
	constructor() {
		if ($('.offence-details').length > 0) {

			$.ajax({
				method: "GET",
				url: $('.fine-details-url').val(),
				success: function (Result) {
					displayOffenceDetails(Result);
					displayFineDetailsSidebar(Result);
					if(!Result.IsCWP){
						displayWarrantDetails(Result);
					}
					displayYourOptions(Result.YourOptions, Result.ObligationNumber, Result.IsCWP, Result.IsEHO);
					displayImageContainer(Result);
					displayImageResult(Result);
					$('#PayYourFineForm-FineDetails').show();
					$('#PayYourFineForm-FineDetails input[name="Identifier"]').val(Result.ObligationNumber);
					if (Result.AlertMessage) {
						$('#FineDetailsAlert').show();
						$('#FineDetailsAlertMessage').html(Result.AlertMessage);
					}
					if(Result.IsCWP){
						$('#further-information').show();
					}
					
				},
				error: function (xhr, ajaxOptions, thrownError) {
					$('.content-holder .cssload-container').hide();
					$('.offence-content-block .cssload-container').hide();
					$('.fine-details .cssload-container').hide();
					$('.offence-content-block').append('<div class="offence-photo-holder error" style=""><span class="error-message">Something went wrong while processing the request.</span></div>');
				}
			});

			function displayWarrantDetails(offence) {
				if (offence.FinesStage == 'Warrant') {
					$('.offence-details-header').removeClass('first');
					$('.warrant-details').show();
					$('#WarrantType').html(offence.WarrantType);
				}
			}

			function displayOffenceDetails(offence) {
				$('.offence-details').show();
				$('.offence-content-block .cssload-container').hide();

				if (offence.TicketType == 'CourtFine_2B') {
					$('.offence-details-header > h4').text('Details');

					$('#OffencedescriptionRow, #OffenceAgencyRow, #OffenceRegistrationNumberRow, #OffenceTimeRow, #OffenceLocationRow,#OffenceDateRow').hide();

					$('.offence-details > tbody').prepend(`<tr><td><span>Type</span></td><td><span>${offence.OffenceDescription}</span></td></tr>`);
					$('.offence-details > tbody').append(`<tr id="OffenceFurtherInfo"><td><span>Court Case Number</span></td><td><span>You may have other charges subject to this court order. For further information, call (03) 9200 8222</span></td></tr>`);

				} else {

					if(offence.IsCWP){
						$('.offence-details-header > h4').text('Details');
						$('.offence-details tr').hide();
						$('.offence-details > tbody').prepend(`<tr><td><span>Type</span></td><td><span>${offence.OffenceDescription}</span></td></tr>`);
						if (offence.OffenceDate) {
							$('#OffenceDateRow').show();
							$('#OffenceDateRow td:first-child').text('CWP – Failure to Report Date');
							$('#OffenceDateRow .offence-content').html(offence.OffenceDate);
						}
						if (offence.InfringementNumber) {							
							$('#CWPReferenceRow').show();
							$('#CWPReferenceRow .offence-content').html(offence.InfringementNumber);
						}
					}else{
						$('#OffencedescriptionRow .offence-content').html(offence.OffenceDescription);

						if (offence.EnforcmentAgency) {
							$('#OffenceAgencyRow .offence-content').html(offence.EnforcmentAgency);
						}
						else {
							$('#OffenceAgencyRow').hide();
						}

						if (offence.VehicleRegistration) {
							$('#OffenceRegistrationNumberRow .offence-content').html(offence.VehicleRegistration);
						}
						else {
							$('#OffenceRegistrationNumberRow').hide();
						}

						if (offence.OffenceTime) {
							$('#OffenceTimeRow .offence-content').html(offence.OffenceTime);
						}
						else {
							$('#OffenceTimeRow').hide();
						}

						if (offence.OffenceLocation) {
							$('#OffenceLocationRow .offence-content').html(offence.OffenceLocation);
						}
						else {
							$('#OffenceLocationRow').hide();
						}
					}
				}


				$('#OffenceDateRow .offence-content').html(offence.OffenceDate);
			}

			function displayFineDetailsSidebar(offence) {
				$('.fine-details .showMe').show();
								
				if (offence.TicketType == "CourtFine_2B") {
					$('.fine-details > h4').text('Court order details');
				}

				if (offence.IsEHO === true) {
					$('.fine-details > h4').text('Court order details');
				}

				if (offence.AdditionalCostIfNotPaid) {
					$('#NextAdCost').html('$' + offence.AdditionalCostIfNotPaid);
					if(offence.FinesStage == 'NoticeOfFinalDemand'){
						$('#NextAdCostText').html(' will be added if an enforcement warrant is issued')
					}
				}
				else {
					$('#nextAdditionalCostText').hide();
				}

				var stageAndIcon = getIconAndFineStateText(offence.FinesStage);
								
				function parseDate(s) {
					var b = s.split(/\D/);
					return new Date(b[2], --b[1], b[0]);
				}
				var todayDate = new Date();
				todayDate = parseDate(todayDate.getDate() + '/' + (todayDate.getMonth() + 1) + '/' + todayDate.getFullYear()).setHours(0, 0, 0, 0);
				var timeLeft = offence.DueDate;
				timeLeft = parseDate(timeLeft).setHours(0, 0, 0, 0);

				$('#obNumber').html(offence.ObligationNumber);


				$('#stage').html(' ' + stageAndIcon.state).addClass(stageAndIcon.icon);
				if (offence.FinesStage == 'ReferredCourtFine') {
					$('#stage').closest('tr').after('<tr><td>Court case number</td><td>' + offence.CourtCase + '</td></tr>');
				}
				if (offence.TicketType == "CourtFine_2B") {
					$('#stage').closest('tr').after('<tr><td>Hearing Date</td><td>' + offence.HearingDate
						+ '</td></tr>' + '<tr><td>Venue</td><td>' + offence.Venue + '</td></tr>')
				}


				if (offence.OnPlan !== "Active") {
					if (offence.DueDate === '31/12/2099') {
						$('#due').html('On hold');
					}
					else if (timeLeft < todayDate) {
						$('#due').html("Overdue");
					}
					else {
						$('#due').html(offence.DueDate);
					}

					if (offence.AmountDue === '0.00') {
						$('#due').html('Closed');
					}
					if (offence.DueDate === 'Refer to notice') {
						$('#due').html('Refer to notice');
					}
					if(offence.IsCWP){
						$('#due').html('Overdue');
					}
				} else {
					$('#due').html('On hold');
				}

				var optionCount = 0;
				$.each(offence.YourOptions, function (key, value) {
					if (value === true) {
						optionCount++;
					}
				});
				if (optionCount === 0) {
					$('.fine-details .options-side').hide();
					$('.fine-details .extra-break').show();
				}

				$('#amount').html('$' + offence.AmountDue);

				if (offence.AmountDue == '0.00') {
					$('#PayYourFineForm-FineDetails [type="submit"]').hide();
				}

				if (offence.FinesStage == 'Infringement' || offence.FinesStage == 'ReferredCourtFine' || offence.TicketType == 'CriminalWarrant_3A') {
					$('.fine-details .addedCostRow').hide();
				}
				else {
					$('#adCost').html('$' + offence.AddedCost);
					if (offence.FinesStage > 1) {
						$('#addedCostLabel').html('Prescribed costs');
					}
				}

				if(offence.IsCWP || offence.IsEHO){
					$('.fine-details .addedCostRow').show();
					$('.fine-details #adCost').html(offence.AddedFee);
				}

				if(offence.isEHO){

					//Hearing Date
					$('.fine-details .hearingDateRow').show();
					$('.fine-details #hearingDate').html(offence.OffenceDate);

					//Venue
					$('.fine-details .venueRow').show();
					$('.fine-details #venue').html(offence.OffenceLocation);
				}


				$('.side-content-holder').hide();
				if (offence.IsCWP) {
					// display the different personalised message for CWP.
	
					$('.fines-detail-sidebar').children('.side-content-holder').eq(1).show();
				} else if(offence.IsEHO){
					$('.fines-detail-sidebar').children('.side-content-holder').eq(2).show();
				} 
				else {
					//it applies the other way around.
					$('.fines-detail-sidebar').children('.side-content-holder').eq(0).show();
				}


			}

			function displayYourOptions(yourOptions, obligationNumber, isCWP = false, isEHO = false) {

				$('.fine-details .cssload-container').hide();											
				$('.fine-details').removeClass('closed');
				if(!isCWP){
					$('.fine-details .options-side').removeClass('closed');	
					if (yourOptions.ShowPayByInstalments) {
						$('#PayByInstalmentsLink').show();
						var urlInstalments = $('#PayByInstalmentsLink').attr('href');
						$('#PayByInstalmentsLink').attr('href', urlInstalments + '#/step0/' + obligationNumber);
	
					}
					if(!isEHO){
						if (yourOptions.ShowPaymentExtension) {
							$('#PaymentExtensionLink').show();
							var urlExtension = $('#PaymentExtensionLink').attr('href');
							$('#PaymentExtensionLink').attr('href', urlExtension + '#/step0/' + obligationNumber);
						}
						if (yourOptions.ShowNominate) {
							$('#NominateLink').show();
							var urlNominate = $('#NominateLink').attr('href');
							$('#NominateLink').attr('href', urlNominate + '#/step0/' + obligationNumber);
						}
						if (yourOptions.ShowRequestAReview) {
							$('#RequestAReviewLink').show();
							var urlReview = $('#RequestAReviewLink').attr('href');
							$('#RequestAReviewLink').attr('href', urlReview + '#/step0/' + obligationNumber);
						}
						if (yourOptions.ShowGoToCourt) {
							$('#GoToCourtLink').show();
							var urlCourt = $('#GoToCourtLink').attr('href');
							$('#GoToCourtLink').attr('href', urlCourt + '#/step0/' + obligationNumber);
						}
					}
					
				}
				
			}

			function displayImageContainer(Result) {
				if (!Result.HasImage) {
					$('.offence-photo-content').hide();
					$('.offence-photo-content').prev('.content-header').hide();
				}
			}

			function displayImageResult(Result) {
				$('.offence-photo-content .cssload-container').hide();
				//will check if null or empty
				if (Result.ObligationNumber) {
					$('.offence-photo-holder').show();
					$('#OffenceImageLink').attr("href", "/api/sitecore/FineDetails/OffencePhotoFile?obligationNumber=" + Result.ObligationNumber);
				}
				else {
					$("#NoImageMessage").show();
				}
			}

			function getIconAndFineStateText(fineStage) {
				var fineState = '';
				var fineIcon = '';
				switch (fineStage) {
					case 'Infringement':
						fineState = 'Infringement Notice';
						fineIcon = 'icon-doc';
						break;
					case 'PenaltyReminder':
						fineState = 'Penalty Reminder';
						fineIcon = 'icon-clock';
						break;
					case 'NoticeOfFinalDemand':
						fineState = 'Notice of Final Demand';
						fineIcon = 'icon-alert';
						break;
					case 'EnforcementOrder':
						fineState = 'Enforcement Order';
						fineIcon = 'icon-gavel';
						break;
					case 'EnforcementWarrant':
						fineState = 'Enforcement Warrant';
						fineIcon = 'icon-badge';
						break;
					case 'EnforcementHearingOrderStatement':
						fineState = 'Enforcement Hearing Order Statement';
						fineIcon = 'icon-gavel';
						break;	
					case 'Warrant':
						fineState = 'Warrant';
						fineIcon = 'icon-badge';
						break;
					case 'ReferredCourtFine':
						fineState = 'Court fine collection statement';
						fineIcon = 'icon-court';
						break;
					default:
						fineState = '';
						fineIcon = '';
						break;
				}

				return {
					icon: fineIcon,
					state: fineState
				};
			}
		}
	}
}